import { __assign } from "tslib";
import * as React from 'react';
import { CarouselChild } from './CarouselChild.js';
import { useCarousel } from '../../hooks/useCarousel.js';
export var CarouselContainer = function (_a) {
    var children = _a.children, _b = _a.interval, interval = _b === void 0 ? 5000 : _b;
    var slides = React.Children.toArray(children);
    var length = slides.length;
    var _c = useCarousel(length, interval), active = _c[0], setActive = _c[1], handlers = _c[2];
    return (length > 0 && (React.createElement("div", { className: "carousel" },
        React.createElement("ol", { className: "carousel-indicators" }, slides.map(function (_, index) { return (React.createElement("li", { onClick: function () { return setActive(index); }, key: index, className: "".concat(active === index ? 'active' : '') })); })),
        React.createElement("div", __assign({ className: "carousel-content" }, handlers),
            React.createElement(CarouselChild, null, slides[slides.length - 1]),
            slides.map(function (slide, index) { return (React.createElement(CarouselChild, { key: index }, slide)); }),
            React.createElement(CarouselChild, null, slides[0])))));
};
//# sourceMappingURL=CarouselContainer.js.map